const TARGET_KEY_OBJECT = "[object Object]"
// const TARGET_KEY_ARRAY = "[object Array]"
// 数组或者对象 => hash
export const arrObjToHash = (source, key) => {
   let target_arr = []
   const target = {}
   const source_type = Object.prototype.toString.call(source)
   switch (source_type) {
       case TARGET_KEY_OBJECT:
        target_arr = Object.values(source)
           break;
       default:
           break;
   }
  for (const value of target_arr) {
      const hash_key = value[key]
      if (['', undefined, null].includes(hash_key)) {
        console.error(`${key}:${hash_key}为空`)
        return 
      }
      if (target[hash_key]) {
          console.error(`${key}:${hash_key}不能作为当前hash键`)
        return 
      }
      target[hash_key] = value
  }
  return target
}